<template>
    <div class="reviewDialog">
        <div class="reviewPage">出动总结</div>
        <div class="review"><el-input type="textarea" placeholder="输入内容"></el-input></div>
        <div style="text-align:center;"><img src="~@/assets/img/submint.png" alt="" @click="update"></div>
    </div>
</template>
<script>
export default {
    data(){
        return{
        }
    },
    methods:{
        update(){
             this.$router.push('home')
        }
    }
}
</script>
<style lang="less" scoped>
.reviewDialog{
    .reviewPage{
        font-size: 24px;
        text-align: center;
        font-family: Source Han Sans CN;
        font-weight: 800;
        color: #FFFFFF;
        line-height: 30px;
        text-shadow: 1px 2px 10px rgba(4, 0, 0, 0.7);
    }
    .review{
       width: 842px;
       margin:78px auto; 
    }
    .el-textarea__inner{
        height: 341px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/reviewDialog.vue